import React, { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
const MirumGrid = ({
  rowData,
  columnDefs,
  addColumnDefs,
  className,
  height,
  showFields,
}) => {
  const gridRef = useRef();
  const [gridColumnDefs, setGridColumnDefs] = useState(columnDefs);
  addColumnDefs = addColumnDefs || [];
  useEffect(() => {
    if (rowData && rowData.length > 0 && !columnDefs) {
      console.log("rowData", rowData);
      let keys = Object.keys(rowData[0]);
      let columnDefs = keys.map((key) => {
        return { headerName: key, field: key };
      });

      //Remove potential duplicates with addColumnDefs
      columnDefs = columnDefs.filter((col) => {
        return !addColumnDefs.find((col2) => {
          return col.field === col2.field;
        });
      });

      if (showFields) {
        columnDefs = columnDefs.filter((col) => {
          return showFields.includes(col.field);
        });
      }
      columnDefs = [...columnDefs, ...addColumnDefs];

      setGridColumnDefs(columnDefs);
    }
  }, [rowData, columnDefs, showFields]);

  return (
    <div className={`h-full w-full ${className ? className : ""}`}>
      <button
        className="bg-[var(--blue)] text-white px-2 py-1 rounded-md mb-2"
        onClick={() => {
          gridRef.current.api.exportDataAsCsv();
        }}
      >
        Export CSV
      </button>
      <div
        className="ag-theme-alpine"
        style={{ height: height ? height : "100%", width: "100%" }}
      >
        <AgGridReact
          columnDefs={gridColumnDefs}
          rowData={rowData}
          ref={gridRef}
        ></AgGridReact>
      </div>
    </div>
  );
};
export default MirumGrid;
